import React, { useState, useRef, useEffect } from "react";

function FilterButtonCapabilityMaps({
  setSearch,
  search,
  industryFilter,
  setIndustryFilter,
  statusFilter,
  setStatusFilter,
  industries,
  industryCounts
}) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const clearFilters = () => {
    setIndustryFilter("all");
    setStatusFilter("all");
    setSearch("");
    setIsOpen(false);
  };

  const hasActiveFilters = industryFilter !== "all" || statusFilter !== "all" || search !== "";

  return (
    <div className="relative inline-flex" ref={dropdownRef}>
      <button
        className={`btn bg-white border-slate-200 hover:border-slate-300 text-slate-500 hover:text-slate-600 ${
          hasActiveFilters ? "border-indigo-300 bg-indigo-50" : ""
        }`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="sr-only">Filter</span>
        <wbr />
        <svg
        className="w-4 h-4 fill-current"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.5 16.5C6.36 16.5 3 13.14 3 9C3 4.86 6.36 1.5 10.5 1.5C14.64 1.5 18 4.86 18 9C18 13.14 14.64 16.5 10.5 16.5ZM10.5 3C7.42 3 5 5.42 5 9C5 12.58 7.42 15 10.5 15C13.58 15 16 12.58 16 9C16 5.42 13.58 3 10.5 3ZM21 21L16.5 16.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
        <span className="hidden sm:block ml-2">Filter</span>
        {hasActiveFilters && (
          <span className="ml-1 text-xs bg-indigo-500 text-white rounded-full px-1.5 py-0.5">
            {(industryFilter !== "all" ? 1 : 0) + (statusFilter !== "all" ? 1 : 0) + (search ? 1 : 0)}
          </span>
        )}
      </button>

      {isOpen && (
        <div className="origin-top-right z-10 absolute top-full right-0 mt-2 w-80 bg-white border border-slate-200 py-4 px-4 rounded-lg shadow-lg">
          <div className="space-y-4">
            {/* Search */}
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">
                Search
              </label>
              <input
                type="text"
                className="form-input w-full"
                placeholder="Search by name, industry..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">
                Industry
              </label>
              <select
                className="form-select w-full"
                value={industryFilter}
                onChange={(e) => setIndustryFilter(e.target.value)}
              >
                <option value="all">All Industries</option>
                {industries.map((industry) => (
                  <option key={industry} value={industry}>
                    {industry}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">
                Status
              </label>
              <select
                className="form-select w-full"
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <option value="all">All Status</option>
                <option value="visible">Visible</option>
                <option value="hidden">Hidden</option>
                <option value="revoked">Revoked</option>
              </select>
            </div>
            <div className="flex justify-between pt-2 border-t border-slate-200">
              <button
                className="text-sm text-indigo-500 hover:text-indigo-600"
                onClick={clearFilters}
              >
                Clear Filters
              </button>
              <button
                className="btn-sm bg-indigo-500 hover:bg-indigo-600 text-white"
                onClick={() => setIsOpen(false)}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default FilterButtonCapabilityMaps;